import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { onboardingSettings } from "./onboardingSettingsQueryKeys";

export function useQueryOnboardingSettings({ api }: { api: ApiType }) {
  return useQuery({
    queryKey: onboardingSettings.all(),
    queryFn: async () => (await api.onboardingSettingsApi.getAll()).data,
  });
}
